<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		paging
		selection
		:excel="isButton_(scrId, 'EX')"
		@changedPage="onChangePage"
		v-bind="taskCommCdMstPagingInfo"
		@row-dblclick="searchTaskCommCdList"
		rowKey="rnum"
		:pageUnit="taskCommCdMstPagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="taskCommCdMstPagingInfo.totalSize"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'mstCdName'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-input v-model="slotProps.row[slotProps.column.property]" maxlength="5" />
				</template>
				<template v-else>
					<span @click="() => onClick(slotProps.row)" :style="{ color: 'blue', fontWeight: 'bold', cursor: 'pointer' }">
						{{ slotProps.row.mstCdName }}
					</span>
				</template>
			</template>
		</template>

		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('MWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>
<script>
import * as yup from 'yup';
import { serviceMethods, serviceComputed } from '@/views/cc/CommonCode/store/helpers';
import { serviceTaskMethods, serviceTaskComputed } from '@/views/qms/TaskCommCd/store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	mounted() {
		this.$sf_toggleLoading(true);
		Promise.all([this.searchTaskCommCdMstOptions_(), this.searchTaskCommCdMst_()]).finally(() => this.$sf_toggleLoading(false));
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		...serviceTaskComputed,
		options() {
			return this.useYnOptions.slice(1, 3);
		},
		rows() {
			return this.taskCommCdMstRows;
		},
		commCdTypeSchema() {
			return yup.object().shape({
				mstCd: yup
					.string()
					.trim()
					.required(this.$sf_formatString(this.getMessage_('MWCC000175'), [this.getMessage_('MWCC000168')]))
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000168'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000168'), 20])),
				mstCdName: yup
					.string()
					.trim()
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000169'), 1]))
					.max(40, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000169'), 40])),
				mstCdDesc: yup
					.string()
					.trim()
					.max(200, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000149'), 200]))
			});
		},
		columns() {
			return [
				{ label: 'No.', prop: 'rnum', width: '130px', custom: true },
				{ label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' },
				{
					label: this.getMessage_('MWCC000168'),
					prop: 'mstCd',
					width: '300px',
					//highlight: true,
					//clickEvent: this.srcMstCd,
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isAdded
					}
				},
				{
					label: this.getMessage_('MWCC000169'),
					prop: 'mstCdName',
					width: '300px',
					//custom: true
					form: {
						type: 'input',
						maxLength: 100,
						isDisabled: this.isAdded
					}
				},
				{
					label: this.getMessage_('MWCC000149'),
					prop: 'mstCdDesc',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 1000
					}
				},
				{
					label: this.getMessage_('MWCC000144'),
					prop: 'mstCdSort',
					width: '130px',
					form: {
						type: 'input',
						maxLength: 4
					}
				},
				{
					label: this.getMessage_('MWCC000145'),
					prop: 'useYn',
					width: '170px',
					form: {
						type: 'select',
						options: this.options
					}
				},
				{ label: this.getMessage_('MWCC000146'), prop: 'regDt', width: '250px' },
				{ label: this.getMessage_('MWCC000005'), prop: 'regId', width: '200px' },
				// { label: this.getMessage_('MWCC000143'), prop: 'regIp', width: '200px' },
				{ label: this.getMessage_('MWCC000171'), prop: 'chgDt', width: '250px' },
				{ label: this.getMessage_('MWCC000172'), prop: 'chgId', width: '200px' }
				// { label: this.getMessage_('MWCC000173'), prop: 'chgIp', width: '200px' },
			];
		}
	},
	methods: {
		...serviceMethods,
		...serviceTaskMethods,
		isAdded: ({ row }) => row.status !== 'I',
		searchTaskCommCdList({ mstCd, status }) {
			if (status === 'I') {
				return;
			}
			this.$sf_toggleLoading(true);
			this.setCurrentTaskCommCdMst_(mstCd);
			this.searchTaskCommCd_({ mstCd, ...this.taskCommCdPagingInfo, currentPage: 1 }).finally(() => this.$sf_toggleLoading(false));
		},
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchTaskCommCdMst_({ currentPage: currentPageVal, pageUnit: pageUnitVal }).finally(() => this.$sf_toggleLoading(false));
		},
		getSelectedRows() {
			const defaultObj = this.commCdTypeSchema.cast();
			const rows = this.$refs.table
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		addRow() {
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addTaskCommCdMstRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		async onClickButton(action) {
			const selectedRows = this.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				const errMsg = this.getMessage_(action === 'save' ? 'MWCC000434' : 'MWCC000418');
				this.$sf_toast({ type: 'error', message: errMsg, option: { duration: 3000 } });

				return;
			}
			const messageCode = {
				save: 'MWCC000501',
				delete: 'MWCC000108'
			}[action];
			const clickFn = {
				save: this.saveRows,
				delete: this.deleteRows
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('MWCC000203')
			});
		},
		async saveRows() {
			const selectedRows = this.getSelectedRows();
			const fail = (
				await Promise.all(
					selectedRows.map(row =>
						this.commCdTypeSchema
							.validate(row)
							.then(() => ({ isValid: true }))
							.catch(e => ({ isValid: false, ...e }))
					)
				)
			).filter(r => !r.isValid);
			if (fail.length > 0) {
				this.$sf_showMessage({ icon: 'error', message: fail[0].message });
				return;
			}
			this.$sf_toggleLoading(true);
			this.saveTaskCommCdMst_(selectedRows)
				.then(({ code, message }) =>
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message
					})
				)
				.finally(() => this.$sf_toggleLoading(false));
		},
		deleteRows() {
			this.$sf_toggleLoading(true);
			this.deleteTaskCommCdMst_(this.getSelectedRows())
				.then(res => res && this.$sf_toast({ ...res, type: res.code === 0 ? 'ok' : 'error' }))
				.finally(() => this.$sf_toggleLoading(false));
		},
		onClick(row) {
			//alert('TableContainer onClick이벤트 발생');
			this.setState_({ key: 'selectedRow', value: row });
			this.$emit('popupOpen', row);
		},
		srcMstCd(row) {
			alert('popupOpen');
			this.editRow = row;
			//this.$emit('PopupOpen');
		}
	},
	watch: {
		rows() {
			const target = _.first(this.$refs.table.$el.getElementsByClassName('el-table__body-wrapper')) || {};
			target.scrollLeft = 0;
		}
	},
	data() {
		return {};
	}
};
</script>

<style>
.rcv_id_label {
	text-decoration: none !important;
}
.rcv_id_blue * {
	color: rgb(40, 40, 255);
	font-weight: bolder;
	cursor: pointer;
	text-decoration: underline;
}
.commonCode__pointerCell {
	cursor: pointer;
}
</style>
